import IPollPoint from "../IPollPoint";

const InitialPollPoint: IPollPoint = {
    id: 0,
    title: "",
};
export default InitialPollPoint;
